<style lang="scss" scoped>
.navbar {
  width: 100%;
  height: 60px;
  position: fixed;
  left: 0;
  top: 0;
  padding: 0 80px;
  border: 0.5px solid rgba(211, 211, 211, 0.2);
  z-index: 2000;
  transition: all 0.6s;


  .left-box {
    padding: 10px 0;
    overflow: hidden;

    .logo {
      // width: 133px;
      // height: 39px;
      cursor: pointer;
    }

    div.menu {
      color: #333333;
      height: 40px;

      .li {
        margin: 0 22px;
        font-weight: 400;
        line-height: 40px;
        position: relative;
        cursor: pointer;

        &::after {
          content: "";
          display: block;
          border-radius: 10px;
          width: 34px;
          height: 2.69px;
          background: rgb(168, 51, 40);
          position: absolute;
          bottom: -13px;
          left: 50%;
          margin-left: -17px;
          transition: all 0.16s;
        }

        &:hover::after {
          bottom: -9px;
        }
      }


      .li.active {
        color: #191919;
        font-size: 17px;
        font-weight: 500;
        font-family: "MicrosoftYaHeiSemibold";

        &::after {
          bottom: -9px;
        }
      }
    }
  }

  .right-box {
    padding: 12px 0 13px;

    .search-box {
      width: 361px;
      height: 34px;
      padding: 0 16px;
      border: 1px solid rgb(223, 223, 223);
      border-radius: 50px;
      background: rgba(255, 255, 255, 0.39);


    }
  }

  ::v-deep() {
    .el-input__inner {
      border: none;
      outline: none;
      line-height: 32px;
      height: 32px;
      padding: 0;
      background-color: transparent;
    }

    input::placeholder {
      color: #BABABA;
      font-size: 14px;
      letter-spacing: 1px;
    }

    .search-box .el-button--primary {
      border: none;
      outline: none;
      font-size: 16px;
      background-color: transparent;
      color: rgb(105, 105, 105);
      padding: 0;
      margin: 0;
    }

    .red-btn {
      border: none;
      outline: none;
      line-height: 34px;
      height: 34px;
      border-radius: 19px;
      padding: 0 16px;
      margin-left: 16px;
      font-size: 14px;
      letter-spacing: 1px;
    }

    .el-dropdown {
      line-height: 34px;
      margin-left: 40px;
      cursor: pointer;

      &:hover {
        color: #409EFF;
      }
    }

    .mass-btn {
      padding: 0;
      border: none;
      background: transparent;
      margin-left: 16px;

      span {
        font-size: 24px;
        line-height: 32px;
      }
    }

    .avatar-box {
      margin-left: 16px;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 1820px) {
  .navbar .right-box .search-box {
    width: 260px;
  }
}

@media screen and (max-width: 1720px) {

  .navbar {
    padding: 0 40px;

    ::v-deep() {
      .el-dropdown {
        margin-left: 20px;
      }
    }
  }

  .navbar .left-box div.menu .li {
    margin: 0 16px;
  }
}

@media screen and (max-width: 1560px) {
  .navbar .left-box div.menu .li {
    margin: 0 10px;
  }
}

@media screen and (max-width: 1480px) {
  .navbar .right-box .search-box {
    width: 160px;
  }
}

@media screen and (max-width: 1360px) {
  .navbar {
    padding: 0 16px;
  }
}

@media screen and (max-width: 1360px) {
  .navbar {
    padding: 0 6px;

    ::v-deep() {
      .el-dropdown {
        margin-left: 10px;
      }
    }
  }
}
</style>

<template>
  <section class="navbar df jcsb" :style="'background: ' + navbg + ';'">
    <div class="left-box df aic">
      <img src="@/assets/images/logo.png" @click="link('/index/index', 'DASHBOARD_LIST')" class="logo" alt="">
      <!-- 菜单 -->
      <div class="df menu">
        <!-- {{ activeMenu }} -->
        <div class="li" :class="{ active: activeMenu == 'DASHBOARD_LIST' }" @click="link('/index/index', 'DASHBOARD_LIST')">
          {{ $t('首页') }}
        </div>
        <div class="li" :class="{ active: activeMenu == 'ACTIVE_LIST' }" @click="link('/activity/index', 'ACTIVE_LIST')">
          {{ $t('活动') }}</div>
        <div class="li"  :class="{ active: activeMenu == 'SUBJECT_LIST' }" @click="link('/subject/list', 'SUBJECT_LIST')">{{ $t('话题') }}</div>

        <div class="li" :class="{ active: activeMenu == 'DISCUSS_LIST' }" @click="link('/discuss/list', 'DISCUSS_LIST')">{{ $t('讨论') }}</div>
        
        <div class="li" @click="handleMenu('/cooperatebusiness/index')">{{ $t('合作') }}</div>
        <div class="li" :class="{ active: activeMenu == 'STATIONED_LIST' }" @click="link('/stationed/index', 'STATIONED_LIST')">
          {{ $t('专家1') }}
        </div>
        <div class="li" @click="handleMenu('/sysarticle/aboutInfo')">{{ $t('关于我们') }}</div>
      </div>
    </div>

    <div class="right-box df aic">
      <!-- 搜索 -->
      <div class="search-box ">
        <el-form class="df" @submit.native.prevent="handelSearch">
          <el-input v-model="form.search" :placeholder="$t('请输入关键字')" maxlength="20" class="f1"></el-input>
          <el-button type="primary" class="fn" @click="handelSearch"><span class="iconfont">&#xe8b9;</span></el-button>
        </el-form>
      </div>
      <!-- 发布按钮 -->
      <el-tooltip placement="top" effect="light" popper-class="new-fabuBtn">
        <div slot="content">
          <div class="new-btns">
            <div class="fs-16 lh-24 harmonyos-text" @click="handelOpenarticle">{{ $t('发文章') }}</div>
            <div class="fs-16 lh-24 harmonyos-text" @click="handleOpenPost">{{ $t('发帖子') }}</div>
          </div>
        </div>
        <el-button class="red-btn" type="primary">{{ $t('内容发布') }}</el-button>
      </el-tooltip>
      <!-- <el-button class="red-btn" type="primary">{{ $t('内容发布') }}</el-button> -->

      <!-- 语言 -->
      <el-dropdown trigger="click" @command="handleChangeLang">
        <span class="el-dropdown-link" style="text-transform: uppercase;">{{ $t(langActive) }}</span>

        <el-dropdown-menu slot="dropdown">

          <el-dropdown-item v-for="item in datalist.lang" :command="item"
            :class="{ 'is-selected': langActive === item.twss_lang }" :key="item.twss_lang">
            {{ item.tws_name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 消息 -->
      <el-popover placement="bottom" width="400" trigger="click">
        <div>

          <div class="mail-box">
            <div class="df jcfe pr-24">
              <el-button type="text" @click="handleAllread()">{{ $t('全部阅读') }}</el-button>
            </div>
            <div v-for="(item, index) in mailList" @click="handleLink(item)" class="li" :class="{ 'reader': item.tfm_status == 2 }"
              :title="item.tfm_content" :key="index">
              <div class="tit harmonyos-text c-3">{{ item.tfm_title }}</div>
              <div class="date fs-13 mt-6 c-9">{{ item.create_time }}</div>
            </div>
          </div>
          <template v-if="mailList.length == 0">
            <div class="no-data">
              <img src="@/assets/images/empty_data.png" alt="">
              <p>{{ $t('暂无数据') }}</p>
            </div>

          </template>
        </div>
        <el-button slot="reference" class="mass-btn" style="position: relative;">
          <span class="iconfont">&#xe600;</span>
          <span v-show="noReadArr > 0" class="iconfont c-them"
            style="font-size: 8px;position: absolute;right: 0px;top:-8px;">&#xea9f;</span>
        </el-button>
      </el-popover>

      <!-- 头像 -->
      <template v-if="!userinfo || userinfo.length == 0">
        <el-button type="text" class="login-btn ml-16" @click="handlelogin">{{ $t('登录') }}</el-button>
      </template>
      <div v-else class="df aic">
        <div @click="handlePersonal">
          <el-avatar class="avatar-box" :size="32" :src="userinfo.user_avatar_att_url" @error="handleImageError">
            <img src="@/assets/images/avatar.png" alt="">
          </el-avatar>
        </div>
        <el-button type="text" class="logout-btn ml-16" @click="handleLogOut()">{{ $t('退出') }}</el-button>
      </div>

    </div>

  </section>
</template>

<script>
import { pathLoac } from "@config";
import { mapGetters, mapActions } from 'vuex';

import Cookies from 'js-cookie';


import { getfrontMsgList } from "@api/common";
import { getMyInfo, editFrontmessage ,userDataLv2} from "@api/home";

import { gettopicList, getcommonData } from "@api/home";


// 发布帖子弹框
import postModel from '../../../components/postModel.vue';
// 文章投稿
import articleModel from '@/components/articleModel.vue';

import { getUrlLocale } from '@/utils/url';

export default {
  components: { articleModel, postModel },
  name: "Navbar",
  
  data() {
    return {
      form: {
        search: '',
      },
      navbg: 'rgba(255, 255, 255, 1)',
      activeMenu: 'DASHBOARD_LIST', // 默认选中首页

      // 语言
      langActive: '中文',

      // 站内信
      mailList: [],
      // 未读
      noReadArr: [],

      userinfo: {

      },


      // 文章
      thumbsId: 0,
      tablist: [],

      data_list: {},
    }
  },
  computed: {
    // ...mapGetters() // 使用命名空间访问 home 模块的 datalist getter
    ...mapGetters('home', ['datalist'])

  },
  async mounted() {

    this.$bus.$on('changeNavbg', (data) => {
      this.navbg = data;
    });


    this.activeMenu = this.$route.meta.personname;

    // 获取用户信息

    localStorage.setItem('userinfo', JSON.stringify({}));

    let res = await getMyInfo();
    if (res.status == 200) {
      this.userinfo = res.data;
      // 获取登录的用户信息
      if (this.userinfo) {
        localStorage.setItem('userinfo', JSON.stringify(this.userinfo));
      }
      if (this.userinfo == null) {
        this.userinfo = [];
      }
    }

    

    this.loadDatalist(); // 组件挂载时自动加载数据


  },
  created() {

    let Language = localStorage.getItem('currentLanguage');  //获取本地语言
    this.langActive = Language

    // this.activeMenu = this.$route.name;


    // 在组件实例创建后立即调用
    // console.log(this.$route.name, this.$router);

  },
  watch: {
    '$route'(to, from) {
      // 路由变化时的逻辑
      this.activeMenu = to.meta.personname;
    }
  },

  methods: {

    handleLogOut() {
      Cookies.remove('accessToken');
      // 刷新当前页面
      location.reload();
    },

    // 个人信息
    handlePersonal() {

      // this.$navigate('/userinfo',null,false);

      let str = "/protal";

      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = "/protal_" + Language;
      } else {
      }
      const url = pathLoac + str + '/usercenter/userinfo'; // 你想要跳转的 URL
      window.location.href = url;

      window.open(url);
    },


    async handelOpenarticle() {

      let checkRes=await userDataLv2();
      if(checkRes.status!=200){
        return false;
      }
      if (this.userinfo.length == 0) {
        setTimeout(() => {
          this.$jumpLogin();
        }, 1000);
        return false;
      }
      this.$bus.$emit('openModalflog', '1');
    },

    handleOpenPost() {
      if (this.userinfo.length == 0) {
        setTimeout(() => {
          this.$jumpLogin();

        }, 1000);
        return false;
      }
      this.$bus.$emit('openModalflog', '2');
    },


    // 搜索

    // pathLoac
    // const url = pathLoac + '/portal' + '/login?callback='; // 你想要跳转的 URL
    // window.open(url);

    handelSearch() {
      // let str = "/protal";

      // let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      // if (Language && Language != 'zh') {
      //   str = "/protal_" + Language;
      // } else {
      // }
      // const url = pathLoac + str + '/search/index/search_key/' + this.form.search; // 你想要跳转的 URL
      // window.open(url);
      const callback = window.location.href;  
      const url = '/search/' + this.form.search; // 你想要跳转的 URL
      this.$navigate(url,null,false);
    },




    // 去登录
    handlelogin() {
      // 加上callback
      const callback = window.location.href;  
      this.$navigate('/login?callback='+callback,null,false);

      // let str = "/protal";
      // let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      // if (Language && Language != 'zh') {
      //   str = "/protal_" + Language;
      // }
      // const url = pathLoac + str + '/login?callback='; // 你想要跳转的 URL
      // window.open(url);
      
    },

    handleImageError() {
      return true;
    },

    // 菜单跳转
    handleMenu(src) {
      let str = "/protal";

      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = "/protal_" + Language;
      }
      const url = pathLoac + str + src; // 你想要跳转的 URL
      window.location.href = url; // 在当前窗口中导航到新的 URL
      // window.open(url);
    },

    // 跳转详情
    async handleLink(src) {
      // 设为已读
      let res = await editFrontmessage({ tfm_id: src.tfm_id });

      this.loadDatalist();
      if (src.tfm_url) {
        const url = src.tfm_url; // 你想要跳转的 URL
        window.open(url);
      }


      // let str = "/protal";
      //
      // let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      // if (Language && Language != 'zh') {
      //   str = "/protal_" + Language;
      // }


    },


    // 全部阅读
    async handleAllread() {
      let res = await editFrontmessage({ read_all: 1 });
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
      this.loadDatalist();
    },

    // 切换语言
    handleChangeLang(data) {
      if (data.twss_lang == 'en') {
        Cookies.set('siteData', '{"tws_id":2,"apply_site":"protal_en"}');
      } else {
        Cookies.set('siteData', '{"tws_id":1,"apply_site":"protal"}');
      }
      localStorage.setItem('currentLanguage', data.twss_lang);
      this.$i18n.locale = data.twss_lang;
      setTimeout(() => {
        this.$forceUpdate();
        // 跳转首页
        window.location.href = '/'
        // window.location.reload();
        // this.$router.go(0);
      }, 20);

    },

    link(url, menu) {
      let str = '/cn';
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = '/' + Language;
      }

      this.activeMenu = menu; // 更新当前选中的菜单项
      this.$router.push(str + url);
    },
    ...mapActions('home', ['fetchDatalist']), // 使用命名空间访问 home 模块的 actions
    async loadDatalist() {
      // 获取站内信
      let res = await getfrontMsgList();
      if (res.status == 200) {
        this.mailList = res.data.userFrontMsgList;
        this.noReadArr = res.data.noReadArr;
      }

      this.fetchDatalist(); // 调用 action 加载数据列表


    }
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    this.$bus.$off('changeNavbg');
  }
};
</script>
<style lang="scss" scoped>
.logout-btn,
.login-btn {
  padding: 0;
  color: #606266;
  margin-left: 16px;
  font-size: 15px;
  margin-top: 2px;

  &:hover {
    color: #9A060B;
  }
}

.el-dropdown-link:hover {
  color: #9A060B;
}

::v-deep() {
  .v-modal {
    z-index: 1000 !important;
  }
}

.no-data {
  text-align: center;
  padding: 26px 0;

  img {
    width: 100px;
  }

  p {
    color: #777777;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 7px;
  }
}

.new-btns {
  .harmonyos-text {
    padding: 4px 12px 4px 12px;
    cursor: pointer;

    &:hover {
      color: #B7251E;
    }

    &:nth-child(n+1) {
      margin-top: 4px;
    }
  }
}

.mail-box {
  padding: 2px;
  max-height: 60vh;
  overflow-y: scroll;

  .li.reader {
    position: relative;
    padding-left: 10px;
  }

  .reader::after {
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #cb1126;
    position: absolute;
    left: -2px;
    top: 10px;
  }

  /* 整个滚动条 */
  &::-webkit-scrollbar {
    width: 4px;
    /* 垂直滚动条的宽度 */
    height: 12px;
    /* 水平滚动条的高度 */
  }

  /* 滚动条轨道 */
  &::-webkit-scrollbar-track {
    background: #fcfbfb;
    /* 轨道背景颜色 */
    border-radius: 10px;
    /* 轨道圆角 */
  }

  /* 滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    background: #B7251E;
    /* 滑块颜色 */
    border-radius: 10px;
    /* 滑块圆角 */
  }

  /* 滚动条滑块悬停时的样式 */
  &::-webkit-scrollbar-thumb:hover {
    background: #B7251E;
    /* 悬停时的滑块颜色 */
  }

  .li:hover {
    background-color: #F5F9FF;
  }

  .li {
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
    // margin-bottom: 12px;
  }
}


::v-deep() {

  .el-popper {
    border-radius: 6px;
    margin-top: 16px;
  }

  .el-dropdown-menu__item.is-selected {
    background-color: #F8E9E9;
    color: #9A060B;
  }

  .el-dropdown-menu {
    padding: 12px 6px;
  }

  .el-dropdown-menu__item {
    border-radius: 4px;
    margin: 2px 0;
  }
}

.el-dropdown-menu {
  padding: 6px 6px;
}
</style>